import TruckingReactAPI from '../../lib/TruckingReactAPI';
import { handleError, error, receive, request } from '../../lib/Utils';
import fetch from 'isomorphic-fetch';
import SwaggerApi, { callApi } from '../../lib/SwaggerApi';

export const CLIENTS = {
  REQUEST: "ORGANIZATIONS_REQUEST",
  SUCCESS: "ORGANIZATIONS_SUCCESS",
  FAILURE: "ORGANIZATIONS_FAILURE"
};

export const UPDATE_CLIENTS = {
  REQUEST: "UPDATE_CLIENTS_REQUEST",
  SUCCESS: "UPDATE_CLIENTS_SUCCESS",
  FAILURE: "UPDATE_CLIENTS_FAILURE"
};

export const CLIENT_QUOTES = {
  REQUEST: "CLIENT_QUOTES_REQUEST",
  SUCCESS: "CLIENT_QUOTES_SUCCESS",
  FAILURE: "CLIENT_QUOTES_FAILURE"
};

export const PLATFORM_ACCESS_REQUEST = {
  REQUEST: "PLATFORM_ACCESS_REQUEST_REQUEST",
  SUCCESS: "PLATFORM_ACCESS_REQUEST_SUCCESS",
  FAILURE: "PLATFORM_ACCESS_REQUEST_FAILURE"
};

export const UPDATE_PLATFORM_ACCESS_REQUEST = {
  REQUEST: "UPDATE_PLATFORM_ACCESS_REQUEST_REQUEST",
  SUCCESS: "UPDATE_PLATFORM_ACCESS_REQUEST_SUCCESS",
  FAILURE: "UPDATE_PLATFORM_ACCESS_REQUEST_FAILURE"
};


export const REMOVE_PLATFORM_ACCESS_REQUEST = {
  REQUEST: "REMOVE_PLATFORM_ACCESS_REQUEST_REQUEST",
  SUCCESS: "REMOVE_PLATFORM_ACCESS_REQUEST_SUCCESS",
  FAILURE: "REMOVE_PLATFORM_ACCESS_REQUEST_FAILURE"
};



let api = new TruckingReactAPI({ domain: '/api' });

export function getOrganizations() {
  return (dispatch) => {   
    dispatch(request(CLIENTS));
    return api
      .getOrganizations()
      .then((payload) => {
        if (payload.ok) {
          payload
            .json()
            .then(json => {
              dispatch(receive(CLIENTS, json));
            });
        } else {
          handleError(dispatch, payload, CLIENTS);
        }

      })
      .catch(function (err) {
        dispatch(error(CLIENTS, {
          message: err.message
        }));
      });
  };
}

export function getQuotes(parameters, callback) {
  return callApi(parameters, "Business", "getQuotes", CLIENT_QUOTES, callback);
}

export function getPlatformAccessRequests(parameters, callback) {
  return callApi(parameters, "Business", "getPlatformAccessRequests", PLATFORM_ACCESS_REQUEST, callback);
}

export function updateRequestPlatformAccess(parameters, callback) {
  return callApi(parameters, "Business", "updateRequestPlatformAccess", UPDATE_PLATFORM_ACCESS_REQUEST, callback);
}

export function removePlatformAccessRequests(parameters, callback) {
  return callApi(parameters, "Business", "removePlatformAccessRequests", REMOVE_PLATFORM_ACCESS_REQUEST, callback);
}

export function updateCustomers(parameters, callback) {
  return callApi(parameters, "Customers", "updateCustomers", UPDATE_CLIENTS, callback);
}



// WEBPACK FOOTER //
// ./src/containers/Clients/ClientsAction.js